import { combineReducers } from "redux";
import createNamedWrapperReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/wrapperReducer";
import topGainersLosers from "./topGainersLosers";
import highestOIGainersLosers from "./HighestOIGainersLosers";
import { EGLType } from "@domains/features/Markets/Futures/entities/Driving Market/iTopGainersLosers";
import { HighOIEGLType } from "@domains/features/Markets/Futures/entities/Driving Market/iHighestOIGainersLosers";
import { HighLowRollverEGLType } from "@domains/features/Markets/Futures/entities/Driving Market/iHighestLowestRollovers";
import highestLowestRollovers from "./HighestLowestRollover";
import highestPremiumDiscount from "./HighestPremiumDiscount";
import { HighPremiumDiscountEGLType } from "@domains/features/Markets/Futures/entities/Driving Market/iHighestPremiumDiscount";
import { EDrivingMarketSectionType } from "@domains/features/Markets/Futures/entities/Driving Market/iDtivingMarket";
import MostActiveByVolume from "./MostActiveByVolume";
import MostActiveByValue from "./MostActiveByValue";
export default combineReducers({
    gain: createNamedWrapperReducer(topGainersLosers, EGLType.GAIN),
    loss: createNamedWrapperReducer(topGainersLosers, EGLType.LOSS),
    highOiGainer: createNamedWrapperReducer(highestOIGainersLosers, HighOIEGLType.HIGHOIGAINER),
    highOiLoser: createNamedWrapperReducer(highestOIGainersLosers, HighOIEGLType.HIGHOILOSER),
    highRollover: createNamedWrapperReducer(highestLowestRollovers, HighLowRollverEGLType.HIGHROLLOVER),
    lowRollover: createNamedWrapperReducer(highestLowestRollovers, HighLowRollverEGLType.LOWROLLOVER),
    highPremium: createNamedWrapperReducer(highestPremiumDiscount, HighPremiumDiscountEGLType.HIGHPREMIUM),
    highDiscount: createNamedWrapperReducer(highestPremiumDiscount, HighPremiumDiscountEGLType.HIGHDISCOUNT),
    activeVolume: createNamedWrapperReducer(MostActiveByVolume, EDrivingMarketSectionType.ACTIVEVOLUME),
    activeValue: createNamedWrapperReducer(MostActiveByValue, EDrivingMarketSectionType.ACTIVEVALUVE),
});
